import React,{ useState, useEffect, useRef} from "react";
import {Button} from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import Select from "react-select";
import Prism from "prismjs";
import "prismjs/components/prism-sql";
import "prismjs/themes/prism.css";
//import "prismjs/themes/prism-okaidia.css";
import "../assets/css/theme.css";
import { getDataApi, loadApi, saveApi} from "../services/appApi";
import axios from "axios";

const GenerateCUDORDS = () => {
    const [darkMode, setDarkMode] = useState(false);
    const [code, setCode] = useState("");
    const [copied, setCopied] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorDialogVisible, setErrorDialogVisible] = useState(false);
    const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] =useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [moduleName, setModuleName] = useState('');
    const [basePath, setBasePath] = useState('');
    const [method, setMethod] = useState('');
    const [fetchOwnerPkgProc, setFetchOwnerPkgProc] = useState(true);
    const [ownerArray, setOwnerArray] = useState([]);
    const [owner, setOwner] = useState([]);
    const [ownerCode, setOwnerCode] = useState({label: "", value: ""});
    const [pkgArray, setPkgArray] = useState([]);
    const [pkg, setPkg] = useState([]);
    const [pkgCode, setPkgCode] = useState({label: "", value: ""});
    const [procArray, setProcArray] = useState([]);
    const [proc, setProc] = useState([]);
    const [procCode, setProcCode] = useState({label: "", value: ""});
    const toast = useRef(null);

    useEffect(() => {
            const fetchOwnerPkgProc = async () => {
              setFetchOwnerPkgProc(true);
              try {
                let res = await axios.get("https://books.radixtax.com/api/lov/getOwnerPkgProcLOV");
                console.log(res)
                if (res) {
                  let successFlag = res.data[0];
                  console.log("Response: ",res);
                  console.log("Success Flag",successFlag);
                  if (successFlag === "Y" && Array.isArray(res.data[1])) {
                    setOwnerArray(res.data[1]);
                    setPkgArray(res.data[2]);
                    setProcArray(res.data[3]);
                    const ownerOptions= res.data[1].map((item)=>({
                      label: item.username,
                      value: item.username
                    }))
                    const pkgOptions= res.data[2].map((item)=>({
                      label: item.object_name,
                      value: item.object_name
                    }))
                    const procOptions= res.data[3].map((item)=>({
                      label: item.procedure_name,
                      value: item.procedure_name
                    }))
                    setOwner(ownerOptions);
                    setPkg(pkgOptions);
                    setProc(procOptions);
                    setFetchOwnerPkgProc(false);
                  } 
                }
              } catch (err) {
                console.log(err);
                setFetchOwnerPkgProc(false);
              }
            };
            fetchOwnerPkgProc();
          }, []);

    const highlightedCode =  Prism.highlight(code, Prism.languages.sql, "sql")

    const copyToClipboard = () => {
        navigator.clipboard.writeText(code);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 2000)
    }

    const lines = highlightedCode.split("\n");

    const fetchCode = async () => {
         const p_param = {
            p_module_name: moduleName,
            p_base_path: basePath,
            p_method: method,
            p_pkg_owner_name: owner.value,
            p_pkg_package_name: pkg.value,
            p_pkg_proc_name: proc.value
        };
          try {
            setIsLoading(true);
            const response = await loadApi(p_param,"/ords/cmn/genCodeScriptsOrdsHandler/v1/");
            console.log("Response:", response);
            const flag = response.data.o_success_flag;
            const data = response.data.o_define_handler;
            if (flag == 'Y') {
              if (data != "") {
                 toast.current.show({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Data fetched successfully'
                })
                console.log("success=Y");
                setCode(data);
                setIsLoading(false);
                setWasDataFetchingSuccessful(false);
              } else {
                //setCode(null);
                setCode("");
                setIsLoading(false);
                const errorInfo = "Error";
    
                // Set the error message and display the dialog
                setErrorMessage(errorInfo);
                setErrorDialogVisible(true);
                setWasDataFetchingSuccessful(true);
              }
              //setSearch(response.data);
            } else {
              //setCode(null);
              setCode("");
              setIsLoading(false);
              const errorInfo = response.data.o_return_msg;
              setErrorMessage(errorInfo);
              setErrorDialogVisible(true);
              setWasDataFetchingSuccessful(true);
            }
    
            //setCode(response.data);
          } catch (error) {
            if(axios.isCancel(error) ||  error.name== 'CanceledError') {
            console.log("Request was cancelled by the user.");
    
            toast.current.show({
              severity: 'warn',
              summary: 'Cancelled',
              detail: 'Request successfully cancelled by the user.',
              life: 3000,
            })
            setIsLoading(false);
          } else {
            console.error("Error fetching data:", error);
          }
        }
        };

 const hideDialog = () => {
    setErrorDialogVisible(false);
  };

  const handleOwnerListChange = (selectedOption) => {
    setPkgCode({label: "", value: ""});
    setProcCode({label: "", value: ""});
    if(selectedOption == null) {
      setOwnerCode({label: "", value: ""});
    } else {
    setOwnerCode(selectedOption);
    console.log("selectedOption :",selectedOption.value)
    const filteredPkg = pkgArray.filter(
      (dt) => dt.owner == selectedOption.value
    );
     const filteredProc = procArray.filter(
      (dt) => dt.owner == selectedOption.value
    );    console.log("Filtered PKG: ",filteredPkg)
    console.log("Filtered Proc: ",filteredProc)
    const pkgOptions1= filteredPkg.map((item)=>({
      label: item.object_name,
      value: item.object_name
    }))
    const procOptions1= filteredProc.map((item)=>({
      label: item.procedure_name,
      value: item.procedure_name
    }))
    setPkg(pkgOptions1);
    setProc(procOptions1);
    }
  }
  const handlePkgListChange = (selectedOption) => {
    setProcCode({label: "", value: ""});
    if(selectedOption == null) {
      setPkgCode({label: "", value: ""});
    } else {
    setPkgCode(selectedOption);
     const filteredProc = procArray.filter(
      (dt) => dt.object_name == selectedOption.value
    );
    const procOptions2= filteredProc.map((item)=>({
      label: item.procedure_name,
      value: item.procedure_name
    }))
    setProc(procOptions2);
    }
  }

  const handleProcListChange = (selectedOption) => {
    if(selectedOption == null) {
      setProcCode({label: "", value: ""});
    } else {
    setProcCode(selectedOption);
    }
  }

  console.log("Package Array: ",pkgArray)
  console.log("Package: ",pkg)

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">Generate CUD ORDS Scripts</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      Generate CUD ORDS Scripts
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

const getModuleName = () => (
  <React.Fragment>
    <div className="flex flex-column">
    <label className="mb-2 font-medium">Module Name</label>
          <InputText 
          type="text"
          id = "moduleName"
          name="moduleName" 
          onChange={(e) => setModuleName(e.target.value)}
          placeholder="Module Name"
          disabled={isLoading}
          style={{padding: "0.55rem 0.75rem"}} />
           </div>
  </React.Fragment>
);

const getBasePath = () => (
  <React.Fragment>
    <div className="flex flex-column">
    <label className="mb-2 font-medium">Base Path</label>
          <InputText 
          type="text"
          id = "basePath"
          name="basePath" 
          onChange={(e) => setBasePath(e.target.value)}
          placeholder="Base Path"
          disabled={isLoading}
          style={{padding: "0.55rem 0.75rem"}} />
           </div>
  </React.Fragment>
);

const getMethod = () => (
  <React.Fragment>
    <div className="flex flex-column">
    <label className="mb-2 font-medium">Method</label>
          <InputText 
          type="text"
          id = "method"
          name="method" 
          onChange={(e) => setMethod(e.target.value)}
          placeholder="Method"
          disabled={isLoading}
          style={{padding: "0.55rem 0.75rem"}} />
           </div>
  </React.Fragment>
);

const getPkgOwnerName = () => (
  <React.Fragment>
      <div className="flex flex-column">
        <label className="mb-2 font-medium">Pkg Owner Name</label>
        <Select
            // className="form-select"
            id="owner"
            name="owner"
            onChange={handleOwnerListChange}
            options={owner}
            value={ownerCode}
            placeholder="Select Pkg Owner Name"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
);

const getPkgPackageName = () => (
  <React.Fragment>
    <div className="flex flex-column">
    <label className="mb-2 font-medium">Pkg Package Name</label>
           <Select
            // className="form-select"
            id="pkg"
            name="pkg"
            onChange={handlePkgListChange}
            options={pkg}
            value={pkgCode}
            placeholder="Select Pkg Package Name"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
           </div>
  </React.Fragment>
);

const getPkgProcName = () => (
  <React.Fragment>
    <div className="flex flex-column">
    <label className="mb-2 font-medium">Pkg Proc Name</label>
         <Select
            // className="form-select"
            id="proc"
            name="proc"
            onChange={handleProcListChange}
            options={proc}
            value={procCode}
            placeholder="Select Pkg Proc Name"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
           </div>
  </React.Fragment>
);

const getGoButtonControl = () => (
  <React.Fragment>
      <div className="flex justify-content-center mt-5">
        <Button icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-spinner"} 
        label={isLoading ? "Loading" : "ORDS Code"} style={{padding: '0.625rem'}} onClick={fetchCode} disabled={isLoading} /> 
      </div>
  </React.Fragment>
  );

return (
    <div>
    <Toast ref={toast} />
    <div className="col mx-2">
      {fetchOwnerPkgProc ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!fetchOwnerPkgProc && (
      <div className="row">
      <div className="col">
    <div className="flex flex-wrap gap-2 justify-content-center align-items-center ">
          {getModuleName()}
          {getBasePath()} 
          {getMethod()}
          {getPkgOwnerName()}
          {getPkgPackageName()}
          {getPkgProcName()}
          {getGoButtonControl()}
    </div>
    </div>
    </div>
    )}
    </div>
    {!wasDataFetchingSuccessful && (
    <div style={{padding: "20px"}}>
        <div className="flex justify-content-between align-items-center mb-3">
            <h2>ORDS Code Viewer:</h2>
            <div className="flex gap-2">
                <Button icon={copied ? "pi pi-check" : "pi pi-copy"} label={copied ? "Copied" : "Copy"} onClick={copyToClipboard}/>
                <Button icon={darkMode ? "pi pi-sun" : "pi pi-moon"} label={darkMode ? "Light" : "Dark"}
                onClick = {() => setDarkMode(!darkMode)}/>
            </div>
        </div>
        <div
        className={darkMode ? "dark-code" : "light-code"}
        style={{
            display: "flex",
            borderRadius: "10px",
            overflow: "auto",
            maxHeight: "450px",
            backgroundColor: darkMode ? "#1e1e1e" : "#f5f5f5",
            color: darkMode ? "#fff" : "#000",
            fontSize: "14px"
        }}
        >
            <div 
            style={{
                padding : "15px 10px",
                textAlign: "right",
                userSelect: "none",
                opacity: "0.6"
            }}>{lines.map((_, i) => (<div key = {i}>{i+1}</div> ))}
            </div>
            <pre style={{margin: 0, padding: "15px", width: "100%"}}>
                <code className = "language-sql" dangerouslySetInnerHTML={{__html: lines.join("\n")}}/>
            </pre>
        </div>
         </div>
        )}
        <Dialog 
            header="API Error" 
            visible={errorDialogVisible} 
            style={{ width: '400px' }} 
            onHide={hideDialog} 
            footer={
                <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
            }
        >    
        <p>
            {errorMessage}
        </p>
        </Dialog>
    </div>
)
}

export default GenerateCUDORDS;